import { Pipe, PipeTransform } from '@angular/core';
import { RequestApplicationModel } from '../models/requests/request-application.model';
import { RequestType } from '../models/requests/request.model';

@Pipe({
    name: 'fromTo',
    pure: true,
    standalone: false,
})
export class FromToPipe implements PipeTransform {
    transform(application: RequestApplicationModel): { from?: string; to?: string } {
        if (!application?.requests?.length) return {};

        const clientRequest = application.requests
            .filter(r => r.fromClient && (r.type === RequestType.Request || r.type === RequestType.UpdateRequest))
            .pop();

        if (!clientRequest?.fieldsValue) return {};

        const parts = clientRequest.fieldsValue
            .split(';')
            .map(p => p.split('=').map(s => s.trim()));

        if (parts.length < 2) return {};

        const fromValue = parts?.[0]?.[1];
        const toValue = parts?.[1]?.[1];

        return {
            from: this.tryParseDate(fromValue) ? fromValue : undefined,
            to: this.tryParseDate(toValue) ? toValue : undefined,
        };
    }

    private tryParseDate(value: string): boolean {
        if (!value) return false;

        // allow only digits, dot, dash, colon, and whitespace
        if (!/^[0-9.\-:\s]+$/.test(value)) return false;

        // must contain at least one dot or dash
        if (!/[.\-]/.test(value)) return false;

        // must contain a 4-digit year
        if (!/\b\d{4}\b/.test(value)) return false;

        return true;
    }
}